import React from 'react';

import { Input as InputComponent, Dropdown as DropdownComponent, Pair } from '../Field';

const AccountInfo = props => {
  // Sola's bankingInformation requires the bank's name; BlueSnap derived it from the routing
  // number, so the wizard never asked.
  const { isSola } = props;
  const Input = inputProps => <InputComponent {...props} {...inputProps} />;
  const Dropdown = dropdownProps => <DropdownComponent {...props} {...dropdownProps} />;

  return (
    <fieldset>
      {isSola && <Input label="Bank Name" id="bankName" placeholder="Bank Name" maxLength="50" />}
      <Input
        label="Routing Number"
        id="bankRoutingNumber"
        placeholder="Routing Number"
        minLength="9"
        maxLength="9"
        inputMode="numeric"
        forget
      />
      <Input
        label="Account Number"
        id="bankAccountNumber"
        placeholder="Account Number"
        // Sola's boarding rule: 6-17 digits, caught here so a short number never reaches
        // the API, which would otherwise reject the whole application. Sola only: BlueSnap
        // validates the number itself through its SDK and its rules are its own.
        minLength={isSola ? '6' : undefined}
        maxLength="17"
        inputMode="numeric"
        forget
      />
      <Input
        label="Bank Account Nickname (Optional)"
        id="bankAccountNickname"
        placeholder="Bank Account Nickname"
        maxLength="15"
        optional
        forget
      />
      <Pair>
        <Dropdown label="Account Type" id="bankAccountType" options={['Checking', 'Savings']} />
        <Input label="Bank Address State" id="bankState" minLength="2" maxLength="2" placeholder="State" />
      </Pair>
    </fieldset>
  );
};

export default AccountInfo;
